<template>
  <div>
    <section-header
      id="fundview"
      :departmentId="departmentId"
      :swiftMove="swiftMove"
      >Fundview</section-header
    >
    <v-btn v-if="addReceiptStatus == 0" @click="addReceiptStatus = 1" small>
      <v-icon>add</v-icon> Receipt
    </v-btn>
    <div class="ajaxForm" v-if="addReceiptStatus != 0">
      <h1>Add receipt</h1>
      <p>Choose receipt from list</p>
      <Unclaimed @claimReceipt="claimReceipt" :isSelecting="true" />
      <v-progress-circular
        indeterminate
        color="info"
        v-if="!receiptsUnclaimed"
      />
      <hr />
      <v-btn @click="addReceiptStatus = 0">Cancel</v-btn>
    </div>
    <div style="font-weight: bold">Receipts (In)</div>
    <v-data-table
      v-if="receipts && receipts.length > 0"
      :headers="headersReceipts"
      :items="receipts"
      hide-actions
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <router-link
              :to="{ name: 'receipt', params: { id: props.item.id } }"
              >{{ props.item.id }}</router-link
            >
          </td>
          <td>{{ props.item.timestamp | formatDate }}</td>
          <td>{{ props.item.sender }}</td>
          <td>{{ props.item.senderreference }}</td>
          <td>{{ props.item.amount | toCurrency }}</td>
          <td>{{ props.item.claimed | booleanConverter }}</td>
          <td>{{ props.item.bacs | booleanConverter }}</td>
        </tr>
      </template>
    </v-data-table>
    <div v-if="receipts != null && receipts.length == 0">No receipts found</div>
    <v-progress-circular indeterminate color="info" v-if="receipts === null" />
    <div style="font-weight: bold; margin-top: 1em">Payments (Out)</div>
    <v-data-table
      v-if="payments && payments.length > 0"
      :headers="headersPayments"
      :items="payments"
      hide-actions
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <router-link
              :to="{ name: 'payment', params: { id: props.item.id } }"
              >{{ props.item.id }}</router-link
            >
          </td>
          <td>{{ props.item.timestamp | formatDate }}</td>
          <td>{{ props.item.bankname }}</td>
          <td>{{ props.item.sortcode }}</td>
          <td>{{ props.item.bankacno }}</td>
          <td>{{ props.item.beneficiary }}</td>
          <td>{{ props.item.amount | toCurrency }}</td>
          <td>{{ props.item.timesent }}</td>
        </tr>
      </template>
    </v-data-table>
    <div v-if="payments && payments.length == 0">No payments found</div>
    <v-progress-circular indeterminate color="info" v-if="!payments" />
  </div>
</template>

<script>
import SectionHeader from "@/components/file/SectionHeader";
import Unclaimed from "@/components/layout/widgets/ReceiptsUnclaimed";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Fundview",
  props: ["departmentId", "swiftMove"],
  components: { SectionHeader, Unclaimed },
  data() {
    return {
      addReceiptStatus: 0,
      receiptsUnclaimed: [],
      receipts: null,
      payments: null,
      headersReceipts: [
        {
          text: "Id",
          value: "id"
        },
        {
          text: "Date",
          value: "timestamp"
        },
        {
          text: "Sender",
          value: "sender"
        },
        {
          text: "Reference",
          value: "senderreference"
        },
        {
          text: "Amount",
          value: "amount"
        },
        {
          text: "Verified",
          value: "claimed"
        },
        {
          text: "Bacs",
          value: "bacs"
        }
      ],
      headersPayments: [
        {
          text: "id",
          value: "id"
        },
        {
          text: "Date",
          value: "timestamp"
        },
        {
          text: "Bank name",
          value: "bankname"
        },
        {
          text: "Sort code",
          value: "sortcode"
        },
        {
          text: "Bank ac no",
          value: "bankacno"
        },
        {
          text: "Beneficiary",
          value: "beneficiary"
        },
        {
          text: "Amount",
          value: "amount"
        },
        {
          text: "Time sent",
          value: "timesent"
        }
      ]
    };
  },
  methods: {
    async fetchPayments() {
      const response = await nbmlaw.get(
        `/cors/admin/file/files/${this.$route.params.id}/payments`
      );
      // console.log(response.data);
      this.payments = response.data;
    },
    async fetchReceipts() {
      const response = await nbmlaw.get(
        `/cors/admin/file/files/${this.$route.params.id}/receipts`
      );
      // console.log(response.data);
      this.receipts = response.data;
    },
    async claimReceipt(id) {
      if (confirm("Are you sure?")) {
        await nbmlaw.post(
          `/cors/admin/file/files/${this.$route.params.id}/receipts/${id}`,
          null
        );
        // console.log(response.data);
        this.fetchReceipts();
        this.addReceiptStatus = 0;
      }
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        this.fetchReceipts();
        this.fetchPayments();
      }
    }
  }
};
</script>
